export const BUILD_NUMBER = '16';
